import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import { FileService } from 'src/app/shared/services/file.service';
import * as XLSX from 'xlsx';
import * as mammoth from 'mammoth';
@Component({
  selector: 'app-upload-material',
  templateUrl: './upload-material.component.html',
  styleUrls: ['./upload-material.component.less']
})
export class UploadMaterialComponent implements OnInit {
  @Input() requestType: string = '';
  selectedRequest: any;
   pdfSrc = "";
   url = "";
   type = "";
   name = "";
   size: number;
   InwardStatus = InwardStatus;
   service_URL: any;
   request: any;
   load: boolean = false;
   docSrc="";
   excelSrc="";
   excelData: any[][] = [];
   fileDataToSubmit: { name: string, type: string, data: string | ArrayBuffer, requestType: string } | null = null;
   selectedFile: File | null = null;
   private unsubscribe$ = new Subject<void>();
   attachedFilesCount: number = 0;
   @Output() showButtonEvent = new EventEmitter<boolean>();
   @Output() close = new EventEmitter<void>();
   @Output() fileData = new EventEmitter<{ name: string, type: string, data: string | ArrayBuffer, requestType: string }>();
   constructor(
     private modalService: BsModalService,
     private _dataContextService: DataContextService,
     private toast: ToastrService,
     private trackeromnitureservice:TrackerOmnitureService,private fileService: FileService
   ) {
     this.service_URL = ConstantsService;
   }
 
   ngOnInit(): void {
    /* var username = localStorage.getItem('email');
     username = username.split('@')[0];
     this.trackeromnitureservice.trackPageloadData('upload-challan',username);
     this.trackeromnitureservice.trackPage("pageView");
     // console.log(this.selectedRequest);*/
   }
 
   Cancel() {
     this.modalService.hide(1);
     $('body').removeClass('modal-open');
   }
 
   UpdateStatus(){
  
   }
   
   GetById(id){
    /* this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
     .pipe(takeUntil(this.unsubscribe$))
     .subscribe(res => {
       this.request = res;
     }
     )*/
   }
 
   Submit() { 
    if (this.selectedFile && this.fileDataToSubmit) {
      this.fileService.addFile(this.fileDataToSubmit);
     // this.fileData.emit(this.fileDataToSubmit); // Emit the file data
      this.showButtonEvent.emit(true);
      this.close.emit(); // Emit the close event
      this.selectedFile = null;
      this.clearViewer();
      this.attachedFilesCount++;
      console.log('Emitting close event'); // Debugging line
      this.modalService.hide(1);
      $('body').removeClass('modal-open');
    }
   
   }
 
   base(event) {
     this.type = event.target.files[0].type;
     this.name = event.target.files[0].name;
     this.size = event.target.files[0].size;
     this.load = true;
 
     // console.log(this.size);
     var mb = ((this.size / 1024) / 1024);
     if (Math.ceil(mb) > 10) {
       this.toast.error("File size is more than 10 MB !");
       this.load = false;
     }
     else {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++){       
        const file = event.target.files[0];
        this.selectedFile = file;
        this.type = file.type;
        const reader = new FileReader();
      
       if (
         this.type === 'image/jpg' ||
         this.type === 'image/jpeg'||
         this.type === 'image/png'
       ) {
         reader.readAsDataURL(file);
         reader.onload = () => {
           this.url = reader.result.toString();
           const base64Data = this.url.split(",")[1];
           this.load = false;
           this.fileDataToSubmit = { name: file.name, type: file.type, data:base64Data, requestType: this.requestType };
           this.fileData.emit(this.fileDataToSubmit);
         };
       }
       else if (this.type === 'application/pdf' ) {
         reader.readAsDataURL(file);
         reader.onload = () => {
           this.pdfSrc = reader.result.toString();
           this.load = false;
           var base64Data = this.pdfSrc.split(",");
           this.fileDataToSubmit = { name: file.name, type: file.type, data: base64Data[1], requestType: this.requestType };
           this.fileData.emit(this.fileDataToSubmit);
         };
       }
       else if (this.type === 'application/msword' 
        || this.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
          reader.readAsArrayBuffer(file);
          reader.onload = () => {
            const arrayBuffer = reader.result as ArrayBuffer;
            mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
              .then((result) => {
               this.docSrc = result.value;
               const reader2 = new FileReader();
               reader2.readAsDataURL(file);
               reader2.onload = () => {
                 const base64Data = reader2.result.toString().split(",")[1];
                 this.fileDataToSubmit = { name: file.name, type: file.type, data: base64Data, requestType: this.requestType };
                 this.fileData.emit(this.fileDataToSubmit);
                 this.load = false;
               };
              })
           
              .catch((err) => {
                console.error(err);
                this.load = false
                          });
        };  
       
       }
       else if (this.type === 'application/vnd.ms-excel' || 
        this.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
        this.type === 'application/vnd.ms-excel.sheet.macroEnabled.12') {
        reader.readAsBinaryString(file);
        reader.onload = (e: any) => {
          const binaryString = e.target.result;
          const workbook = XLSX.read(binaryString, { type: 'binary' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          this.load = false;
          const base64Data = btoa(binaryString); // Convert binary string to base64
          this.fileDataToSubmit = { name: file.name, type: file.type, data: base64Data, requestType: this.requestType };
          this.fileData.emit(this.fileDataToSubmit)
        };
      }
       else {
         this.toast.error("Please Check File Type !");
         this.load = false;
       }
     }
     // console.log(this.url);
   }
  }
  clearViewer(): void {
    this.pdfSrc = '';
    this.docSrc = '';
    this.url = '';
    this.excelData = [];
    this.type = '';
    this.load = false;
  }
  isSubmitDisabled(): boolean {
    return this.attachedFilesCount >= 3 || !(typeof this.pdfSrc === 'string' && this.pdfSrc.length > 0 ||
             typeof this.url === 'string' && this.url.length > 0 ||
             typeof this.docSrc === 'string' && this.docSrc.length > 0 ||
             this.excelData.length > 0);
  }
  private unicodeToBase64(str: string): string {
    return btoa(unescape(encodeURIComponent(str)));
  }
}
